module.exports = __webpack_public_path__ + "img/my_wallet_balance_background.d675d529.png";